import React, {useState, useCallback, useEffect} from 'react';
import {Button, Input, Space, Table} from 'antd';
import {useNavigate, useSearchParams} from 'react-router-dom'

import Api from "../../api";
import {filterJSON} from "../../util/transfer"

export default function TeacherIndex () {
    let [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();

    let pageIndex = searchParams.get('pi') || 1
    let lecturerName = searchParams.get('lecturerName')
    let time = searchParams.get('t')

    const [list, setList] = useState([])
    const [total, setTotal] = useState(0)
    const [loading, setLoading] = useState(false)
    const [searchOptions, setSearchOptions] = useState({})

    useEffect(()=>{
        loadData();
    },[pageIndex, lecturerName,time])

    const doSearch = useCallback((options) => {
        options.t = Date.now()
        setSearchOptions(filterJSON(options))
        setSearchParams(filterJSON(options))
    })


    const loadData = useCallback(()=>{
        if (loading) return;
        setLoading(true)
        Api.getLecturerList({
            pageIndex,
            lecturerName
        }).then(resp=>{
            setLoading(false)
            setList(resp.list||[])
            setTotal(resp.totalCount)
        })
    })


    const columns = [
        {
            title: '编号',
            key: 'lecturerId',
            render: (_, record) => {
                return <span>{record.lecturerId}</span>
            }
        },
        {
            title: '昵称',
            key: 'lecturerName',
            render: (_, record) => {
                return <div className="flexbox align-center">
                    <img style={{width: 40,height: 40, borderRadius:20}} src={record.headImg}/>
                    <span className="mgl10 bold">{record.lecturerName}</span>
                </div>
            }
        },
        {
            title: '头衔',
            dataIndex: 'title',
            key: 'title',
            render: (title) => {
                return <span className="gray">{title}</span>
            }
        },
        {
            title: '关联课程',
            width: 120,
            align: 'center',
            key: 'coursesNumber',
            render: (_, record) => (
                <span>{record.coursesNumber}</span>
            ),
        }, {
            title: '粉丝数',
            width: 120,
            align: 'center',
            key: 'fansNumber',
            render: (_, record) => (
                <span>{record.fansNumber}</span>
            ),
        }, {
            title: '操作',
            key: 'action',
            width: 120,
            align: 'center',
            render: (_, record) => (
                <Space size="middle" wrap>
                    <Button type="link" onClick={() => update(record)}>编辑</Button>
                </Space>
            ),
        },
    ];

    const update = useCallback((record) => {
        navigate('/teacher/'+record.lecturerId)
    })

    const onPagination = useCallback(function (index){
        setSearchParams({...searchOptions,'pi':index})
    })

    return (
        <div style={{minWidth: 800, maxWidth: 1400}}>
            <SearchBar onSearch={doSearch} defaultValue={lecturerName}/>
            <Table
                columns={columns}
                dataSource={list}
                rowKey="lecturerId"
                pagination={{
                    total: total,
                    current: parseInt(pageIndex),
                    pageSize: 10,
                    showSizeChanger: false,
                    onChange: onPagination
                }}
            />
        </div>
    );
};

function SearchBar({onSearch, defaultValue}) {
    const [lecturerName,setLecturerName] = useState(defaultValue)

    const resetOptions = useCallback(()=>{
        setLecturerName()
    })

    const doSearch = useCallback(()=>{
        onSearch && onSearch({
            lecturerName
        })
    })

    return (
        <div className="white-bg pdh16 pdv32 mgv12">
            <div className="flexbox wrap align-center mgb12">
                <div>
                    <span>昵称：</span>
                    <Input
                        value={lecturerName}
                        onChange={(e)=>setLecturerName(e.target.value)}
                        placeholder="请输入" style={{width: 200, height: 32, marginRight: 32}}/>
                </div>
                <Space>
                    <Button type="primary" onClick={doSearch}>查询</Button>
                    <Button onClick={resetOptions}>重置</Button>
                </Space>
            </div>
        </div>
    )
}

